import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import User from './entity'
import Role from '../role/entity'
import Tree from "@/store/shared/entity/tree"
import ResetPassword from './reset-password'

interface UserState extends ListStateItem<User>{
    editUser:User,
    roles:Role[],
    chooseResult:Array<Tree>,
    resetPasswordData:ResetPassword,
    businessGroup:string;
}

class UserModule extends ListModuleItem<UserState,any,User>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editUser:new User(),
        roles:new Array<Role>(),
        chooseResult: new Array<Tree>(),
        resetPasswordData:new ResetPassword(),
        businessGroup:""
    }
    actions={
        async getAll(context:ActionContext<UserState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/User/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<User>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<UserState,any>,payload:any){
            await $http.post('services/app/User/Create',payload.data);
        },
        async update(context:ActionContext<UserState,any>,payload:any){
            if(payload.data.email == ""){
                payload.data.email = null;
            }
            await $http.put('services/app/User/Update',payload.data);
        },
        async delete(context:ActionContext<UserState,any>,payload:any){
            await $http.delete('services/app/User/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<UserState,any>,payload:any){
            let reponse=await $http.get('services/app/User/Get?Id='+payload.id);
            return reponse.data.result as User;
        },
        async getRoles(context:ActionContext<UserState,any>){
            let reponse=await $http.get('services/app/User/GetRoles');
            context.state.roles=reponse.data.result.items as Role[];
        },
        async changeLanguage(context:ActionContext<UserState,any>,payload:any){
            await $http.post('services/app/User/ChangeLanguage',payload.data);
        },
        async getChooseResult(context:ActionContext<UserState,any>, payload:any){
            let response = await $http.get('services/app/User/SelectUser');
            context.state.chooseResult = response.data.result as Array<Tree>;
        },
        async resetPassword(context:ActionContext<UserState,any>, payload:any){
            await $http.post('services/app/User/ResetPassword',payload.data);
        },
        // 是否为业务组
        async isBusinessGroupHead(context:ActionContext<UserState,any>){
            let response = await $http.post('services/app/User/IsBusinessGroupHead');
            context.state.businessGroup = response.data.result as string;
        }
    };
    overrideMutations={
        edit(state:UserState,user:User){
            state.editUser=user;
        },
        setResetPassword(state:UserState,model:ResetPassword){
            state.resetPasswordData = model;
        }
    }
}
const userModule=new UserModule();
export default userModule;